import type { BaseStyledComponentDto, StylesDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

const Styles = ({ fontType = '', fontColor = '', size = '' }): StylesDto => ({
  fontType: String(fontType),
  fontColor: String(fontColor),
  size: String(size),
});

type TextStyledComponentDto = BaseStyledComponentDto & {
  text: string;
  ctaType: string;
  url: string;
};

const TextStyledComponentConstructor = ({
  text = '',
  type = '',
  styles = {},
  ctaType = '',
  url = '',
}): TextStyledComponentDto => ({
  text: String(text),
  type: String(type),
  styles: Styles(styles),
  ctaType: String(ctaType),
  url: String(url),
});

export type { TextStyledComponentDto };
export { TextStyledComponentConstructor };

export type TextStyledComponentProps = ReturnType<typeof TextStyledComponentConstructor>;
